export default function BookingSection({ title, icon: Icon, children }) {
  return (
    <section className="panel-premium booking-section">
      <header className="booking-section__head">
        {Icon && (
          <span className="booking-section__icon" aria-hidden>
            <Icon size={20} />
          </span>
        )}
        <h3>{title}</h3>
      </header>
      <div className="booking-section__body">{children}</div>
    </section>
  );
}
